import React from "react";

import Settings from "../settings";

const CategoryCard = ({ category }: { category: any }) => {
  const style = {
    backgroundColor: category?.color ?? "transparent"
  };
  const categoryText = category?.category ?? "";
  const categoryImageUrl = `${Settings.apiUrl}/categories/${category.id}/image/thumb`;

  return (
    <div style={style} className="category-card">
      <img src={categoryImageUrl} alt={category.category} />
      <span className="mobile-hidden">{categoryText}</span>
    </div>);
};

export default CategoryCard;